import type {ReactElement} from 'react';
import {selectPageIdsWithRemoteSessions} from '@Components/poster-editor/poster-presence-reducer';
import {PagePresenceLayer} from '@Components/poster-editor/components/poster-presence-overlay/components/page-presence-layer/page-presence-layer';
import {useAppSelector} from '@/hooks';

/** Mounts one cursor-and-selection layer on every page that another editor is currently on. */
export function PosterPresenceOverlay(): ReactElement {
  const pageIds = useAppSelector(selectPageIdsWithRemoteSessions);
  return (
    <>
      {pageIds.map((pageId) => (
        <PagePresenceLayer key={pageId} pageId={pageId} />
      ))}
    </>
  );
}
